let accessToken = localStorage.getItem("access_token") || "";

export const setAccessToken = (token) => {
  accessToken = token;
  localStorage.setItem("access_token", token);
};

export const getAccessToken = () => {
  return accessToken;
};
